export default[
    {
        path: 'experience',
        name: 'Experience',
        component:
            () => import(/* webpackChunkName: "experienceManage" */ '@/views/company/experienceManage/index.vue'),
    },
];
